import { render, staticRenderFns } from "./UDIinventory.vue?vue&type=template&id=7cd6dd25&scoped=true"
import script from "./UDIinventory.vue?vue&type=script&lang=js"
export * from "./UDIinventory.vue?vue&type=script&lang=js"
import style0 from "./UDIinventory.vue?vue&type=style&index=0&id=7cd6dd25&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7cd6dd25",
  null
  
)

export default component.exports